<span pTooltip="Refresh" tooltipPosition="bottom">
  <p-button
    ariaLabel="Refresh"
    icon="pi pi-refresh"
    styleClass="p-button-secondary"
    [disabled]="disabled"
    (click)="refresh.emit()">
  </p-button>
</span>
